import type { SalesTaxV2 } from "@credit-acceptance/step6-bff-client";

/** The sales tax section plus the state-rule flags the BFF is expected to supply. */
export type SalesTaxWithRuleFlags = SalesTaxV2 & { netOfTrade?: boolean; netOfRebate?: boolean };

export type SalesTaxMessageKey =
  | "financial.salesTaxModal.messages.netOfTrade"
  | "financial.salesTaxModal.messages.netOfTradeAndRebate"
  | "financial.salesTaxModal.messages.netOfRebate";

/**
 * Picks the info message for the Sales Tax popup from the two state-rule flags.
 * @param salesTax - The `salesTax` block of the itemization.
 * @returns {SalesTaxMessageKey | undefined} The message key, or `undefined` when neither flag is set.
 */
export function selectSalesTaxMessageKey(salesTax?: SalesTaxWithRuleFlags): SalesTaxMessageKey | undefined {
  const netOfTrade = salesTax?.netOfTrade === true;
  const netOfRebate = salesTax?.netOfRebate === true;
  if (netOfTrade && netOfRebate) {
    return "financial.salesTaxModal.messages.netOfTradeAndRebate";
  }
  if (netOfTrade) {
    return "financial.salesTaxModal.messages.netOfTrade";
  }
  return netOfRebate ? "financial.salesTaxModal.messages.netOfRebate" : undefined;
}
